module.exports = __webpack_public_path__ + "static/media/C.cbea7505.png";